import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import LoginCon from "../../../containers/login/login-cont";
import BasicDetailsCont from "../../../containers/basicDetails/basicDetailsCont";
import SurveyUp from "../../UI/maturityMatrix/SurveyUp";
// import SignupContainer from "../../../containers/signup/signupContainer";
import Drawer from "../../widgets/phase-3/policies/drawer";
import {
  LoginContainer,
  SignupContainer,
  VerifyContainer,
} from "containers/Auth";
import ResetPassword from "components/widgets/phase-3/AuthRight/ResetPassword/ResetPassword";
import MaterialityQuestion from "components/widgets/phase-3/MaterialityMapping/assign/left/MaterialityQuestion";
import SupplierSurveyLoginScreen from "components/screen/supplierSurveyLoginScreen/SupplierSurveyLoginScreen";
import MaturitySurvey from "components/widgets/phase-3/esgMaturity/MaturitySurvey";
// import Controller from "../../../containers/router/controllerCont";

const UnauthenticatedRoutes = () => {
  const routes = [
    { path: "/", element: <SignupContainer /> },
    // { path: "/auto_login", element: <LoginCon /> },
    { path: "/login", element: <LoginContainer /> },
    { path: "/survey/:survey_id", element: <SupplierSurveyLoginScreen /> },

    { path: "/verify", element: <VerifyContainer /> },
    { path: "/drawer", element: <Drawer /> },
    { path: "/faq", element: <Drawer /> },
    { path: "/privacy_policy", element: <Drawer /> },
    { path: "/tnc", element: <Drawer /> },
    { path: "/reset_password", element: <ResetPassword /> },
    { path: "/reset_password/:resetcode", element: <ResetPassword /> },
    { path: "/basicDetails", element: <BasicDetailsCont /> },
    { path: "/maturity_matrix", element: <SurveyUp /> },
    { path: "*", element: <Navigate to="/login" /> },
    {
      path: "/materiality/:category/:id",
      element: <MaterialityQuestion survey hasEditable />,
    },
    {
      path: "/maturity/:org_id/:id",
      element: <MaturitySurvey />,
    },

    // { path: "*", element: <NotFound /> } // Optional: Handle unknown routes
  ];

  const element = useRoutes(routes);

  return element;
};

export default UnauthenticatedRoutes;
